module.exports = __webpack_public_path__ + "img/Til-yellow.93d254c8.png";